module.exports = __webpack_public_path__ + "img/java_swings.fcf78c60.jpg";